export default __webpack_public_path__ + "static/cookie-333a729ca5572e6d3819aa5cd734ed24.png";